import classNames from 'classnames';

import { Button } from './button';
import { ButtonProps } from './button.types';
import { BUTTON_VARIANT_M } from './config';

export const ButtonPrimary = ({
  disabled,
  fakeDisabled = false,
  variant = BUTTON_VARIANT_M,
  children,
  className,
  ...props
}: ButtonProps) => {
  const looksDisabled = disabled || fakeDisabled;
  return (
    <Button
      disabled={disabled}
      fakeDisabled={fakeDisabled}
      {...props}
      className={classNames(className, {
        'fill-dark focus:fill-dark-active text-negative': !looksDisabled,
        'fill-dark-disabled text-disabled': looksDisabled,
      })}
      borderClasses='border-0'
      variant={variant}>
      {children}
    </Button>
  );
};
